import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Brush } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";
import { FileUpload } from "../landing/FileUpload";
import { inr } from "../landing/usePricing";

const Job = ({ j, reload }) => {
  const [km, setKm] = useState("");
  const s = j.shift;
  const act = (path, msg, body) => adminApi.post(path, body).then(() => { toast.success(msg); reload(); }).catch((e) => toast.error(errorMessage(e)));
  const photo = (kind) => (f) => f && act(`/worker/hk/jobs/${j.id}/photo`, `${kind === "before" ? "Before" : "After"} photo saved`, { kind, file_id: f.id });
  return (
    <article data-testid={`hk-job-${j.id}`} className="space-y-3 border border-white/10 bg-[#0F172A] p-5">
      <p className="font-semibold text-white">{j.service_label} <span className="font-mono text-xs text-orange-300">{j.reference}</span></p>
      <p className="text-sm text-slate-400">{j.date} · {j.slot} · {j.address}{j.materials ? " · carry materials" : ""}</p>
      {!s && <button onClick={() => act(`/worker/hk/jobs/${j.id}/check-in`, "Checked in")} data-testid={`hk-checkin-${j.id}`} className="bg-emerald-600 px-4 py-2 text-sm font-semibold text-white">Check in</button>}
      {s && !s.check_out && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <FileUpload testId={`hk-before-${j.id}`} label={s.before_photo_id ? "Before photo ✓" : "Before photo"} docType="job_photo" value={null} onChange={photo("before")} accept="image/jpeg,image/png" hint="required" />
          <FileUpload testId={`hk-after-${j.id}`} label={s.after_photo_id ? "After photo ✓" : "After photo"} docType="job_photo" value={null} onChange={photo("after")} accept="image/jpeg,image/png" hint="required" />
          <input value={km} onChange={(e) => setKm(e.target.value.replace(/[^\d.]/g, ""))} placeholder="Travel km (optional)" data-testid={`hk-km-${j.id}`} className="h-10 border border-white/15 bg-[#0B1120] px-3" />
          <button onClick={() => act(`/worker/hk/jobs/${j.id}/check-out`, "Checked out", { travel_km: km ? Number(km) : null })} data-testid={`hk-checkout-${j.id}`} className="bg-orange-500 px-4 py-2 text-sm font-semibold text-white">Check out & complete</button>
        </div>
      )}
      {s?.check_out && (
        <p data-testid={`hk-payout-${j.id}`} className="text-sm text-emerald-300">
          {s.hours} h · wage {inr(s.wage)} + overtime {inr(s.overtime_pay)} + travel {inr(s.travel_allowance)}{s.bonus ? ` + 5★ bonus ${inr(s.bonus)}` : ""} = <b>{inr(s.total_payout)}</b>
        </p>
      )}
    </article>
  );
};

export const TodayJobs = () => {
  const [jobs, setJobs] = useState([]);
  const load = useCallback(() => adminApi.get("/worker/hk/jobs").then((r) => setJobs(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const today = new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);
  const open = jobs.filter((j) => j.status !== "completed");
  const done = jobs.filter((j) => j.status === "completed").slice(-5);
  if (!jobs.length) return null;
  return (
    <section data-testid="hk-today-jobs" className="space-y-3">
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><Brush className="h-5 w-5 text-orange-400" />Cleaning Jobs</h2>
      {open.map((j) => <div key={j.id}>{j.date === today && <p className="mb-1 text-xs font-semibold uppercase text-emerald-300">Today</p>}<Job j={j} reload={load} /></div>)}
      {done.length > 0 && <p className="pt-2 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">Recently completed</p>}
      {done.map((j) => <Job key={j.id} j={j} reload={load} />)}
    </section>
  );
};
